import React from 'react';

import * as S from './NoRequests.styles';

const NoRequests = ({
    icon,
    heading,
    description,
    cta,
    width,
    setModalFlag
}) => {
    if (typeof window === 'undefined') {
        return null;
    }

    const handleClick = () => {
        setModalFlag(true);
    }

    return (
        <S.noReq width={width}>
            {icon && <S.Icon src={icon} />}
            {heading && <S.Heading>{heading}</S.Heading>}
            {description && <S.Description dangerouslySetInnerHTML={{ __html: description }} />}
            {cta && <S.Cta onClick={handleClick}>{cta}</S.Cta>}
        </S.noReq>
    )
}

export default NoRequests;